import { CurrencyOptionGq } from './../../../graphql/projects/models/CurrencyOptionGq';
import { currencyList } from '../../../graphql/projects/models/Currencies';

const currencyOptionRecords: Record<string, CurrencyOptionGq> = {};
currencyList.map((currency) => (currencyOptionRecords[currency.code] = currency));

export function formatCurrency(currency?: string, numberPart?: string | number) {
  if (!currency) return `${numberPart}`;

  const currencyOption = currencyOptionRecords[currency];
  if (!currencyOption) return `${numberPart} ${currency}`;
  if (currencyOption.symbolPlacement === 'after') return `${numberPart} ${currencyOption.symbol}`;
  return `${currencyOption.symbol}${numberPart}`;
}
